const styles = {
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    overflow: 'scroll',
    maxHeight: 'calc(100% - 100px)',
  },
  loaderWrapper: {
    width: '100%',
    display: 'flex',
    padding: 24,
    justifyContent: 'center',
  },
}
export default styles



// WEBPACK FOOTER //
// ./src/Components/Chat/ChatConversationsList/styles.js